import type { AbortRequestFor } from '../../state/createInitialState';
import { abortRequests } from '../../state/createInitialState';

export function abortRequestFor(which: AbortRequestFor<unknown> | undefined) {
  if (which !== undefined) {
    abortRequests.get(which.abortRequest)?.();
  }
}
